import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";
import { List, ListItem, Box } from "@mui/material";

import PageLoader from "components/common/PageLoader";

import { getFullMonthYearFromDate } from "helpers";
import { MONTH_NAMES } from "constants";

import BackButtonIcon from "assets/images/left-arrow.svg";
import TopHeader from "components/common/TopHeader";

import useBreadcrumbs from "hooks/useBreadcrumbs";

function EmployeeSlipsHeader({
  open,
  setOpen,
  selectedYear,
  setSelectedYear,
  selectedMonth,
  setSelectedMonth,
  filters,
  setPayrollId,
  openMonth,
  setMonthOpen,
}) {
  return (
    <div className="bg-white p-1 mt-075 rounded-xl flex items-center">
      <p className="title-sm mr-05 neutral-60a">Filter</p>
      <div className="employee-stubs-grid-header">
        <div style={{ position: "relative" }}>
          <button
            id="year-paystubs"
            type="button"
            style={{
              border: "1px solid #777680",
              borderRadius: "22px",
              padding: "6px 10px 6px 16px",
              color: "#3D3E5C",
              backgroundColor: "transparent",
              fontFamily: "Poppins",
              fontSize: "12px",
              lineHeight: "16px",
              letterSpacing: "0.1px",
              cursor: "pointer",
              whiteSpace: "nowrap",
              display: "flex",
              flexDirection: "column",
              borderBottom: `${open ? "none" : "1px solid #777680"}`,
              borderBottomLeftRadius: `${open ? "0px" : "22px"}`,
              borderBottomRightRadius: `${open ? "0px" : "22px"}`,
            }}
            onClick={() => setOpen(!open)}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {selectedYear}
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 7.5L9 11.25L12.75 7.5H5.25Z" fill="#3D3E5C" />
              </svg>
            </div>
          </button>
          {open && (
            <List
              sx={{
                position: "absolute",
                top: "16px",
                left: "0px",
                padding: "12px 0px 16px",
                marginTop: "12px",
                listStyle: "none",
                width: "100%",
                border: "1px solid #777680",
                borderRadius: "22px",
                borderTop: `${open && "none"}`,
                borderTopLeftRadius: `${open && "0px"}`,
                borderTopRightRadius: `${open && "0px"}`,
                backgroundColor: "#FFFFFF",
              }}
            >
              {filters?.map((yearlyData) => {
                const year = yearlyData?.year;
                return (
                  <ListItem
                    onClick={() => {
                      setSelectedMonth(yearlyData?.months?.[0]?.month);
                      setSelectedYear(year);
                      setOpen(false);
                      setPayrollId(yearlyData?.months[0]?.payrollId);
                    }}
                    sx={{
                      padding: "6px 16px",
                      fontFamily: "Poppins-Medium",
                      fontSize: "14px",
                      lineHeight: "20px",
                      cursor: "pointer",
                      color: selectedYear === year ? "var(--color-primitives-primary-500)" : "#3D3E5C",
                      backgroundColor: selectedYear === year ? "var(--color-primitives-primary-50)" : "unset",
                      "&:hover": {
                        backgroundColor: "var(--color-primitives-primary-50)",
                        color: "var(--color-primitives-primary-500)",
                      },
                    }}
                  >
                    {year}
                  </ListItem>
                );
              })}
            </List>
          )}
        </div>

        <div style={{ position: "relative", marginLeft: "12px" }}>
          <button
            id="year-paystubs"
            type="button"
            style={{
              width: "7rem",
              border: "1px solid #777680",
              borderRadius: "22px",
              padding: "6px 10px 6px 16px",
              color: "#3D3E5C",
              backgroundColor: "transparent",
              fontFamily: "Poppins",
              fontSize: "12px",
              lineHeight: "16px",
              letterSpacing: "0.1px",
              cursor: "pointer",
              whiteSpace: "nowrap",
              display: "flex",
              flexDirection: "column",
              borderBottom: `${openMonth ? "none" : "1px solid #777680"}`,
              borderBottomLeftRadius: `${openMonth ? "0px" : "22px"}`,
              borderBottomRightRadius: `${openMonth ? "0px" : "22px"}`,
            }}
            onClick={() => setMonthOpen(!openMonth)}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {MONTH_NAMES[selectedMonth]}
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 7.5L9 11.25L12.75 7.5H5.25Z" fill="#3D3E5C" />
              </svg>
            </div>
          </button>
          {openMonth && (
            <List
              sx={{
                position: "absolute",
                top: "16px",
                left: "0px",
                padding: "12px 0px 16px",
                marginTop: "12px",
                listStyle: "none",
                width: "100%",
                border: "1px solid #777680",
                borderRadius: "22px",
                borderTop: `${openMonth && "none"}`,
                borderTopLeftRadius: `${openMonth && "0px"}`,
                borderTopRightRadius: `${openMonth && "0px"}`,
                backgroundColor: "#FFFFFF",
              }}
            >
              {filters
                .find((f) => f.year === selectedYear)
                ?.months.map((month) => {
                  return (
                    <ListItem
                      onClick={() => {
                        setSelectedMonth(month.month);
                        setMonthOpen(false);
                        setPayrollId(month?.payrollId);
                      }}
                      sx={{
                        padding: "6px 16px",
                        fontFamily: "Poppins-Medium",
                        fontSize: "14px",
                        lineHeight: "20px",
                        cursor: "pointer",
                        color: selectedMonth === month.month ? "var(--color-primitives-primary-500)" : "#3D3E5C",
                        backgroundColor: selectedMonth === month.month ? "var(--color-primitives-primary-50)" : "unset",
                        "&:hover": {
                          backgroundColor: "var(--color-primitives-primary-50)",
                          color: "var(--color-primitives-primary-500)",
                        },
                      }}
                    >
                      {MONTH_NAMES[month.month]}
                    </ListItem>
                  );
                })}
            </List>
          )}
        </div>
      </div>
    </div>
  );
}

function PayslipPageLayout({
  month,
  loadingPaySlipDetails,
  navigate,
  open,
  setOpen,
  selectedYear,
  setSelectedYear,
  selectedMonth,
  setSelectedMonth,
  filters,
  setPayrollId,
  openMonth,
  setMonthOpen,
  children,
}) {
  const { platformHeader } = useFlags();
  const location = useLocation();
  const { setLabel, resetLabels } = useBreadcrumbs();

  useEffect(() => {
    setLabel(location.pathname, `Pay slip - ${getFullMonthYearFromDate(month)}`);
  }, [location.pathname, month]);

  useEffect(() => {
    return () => resetLabels();
  }, []);

  return (
    <div>
      <Helmet>
        <title>{`Edge | Pay slip - ${getFullMonthYearFromDate(month)}`}</title>
      </Helmet>
      {loadingPaySlipDetails && <PageLoader />}

      {platformHeader && (
        <TopHeader title={`Pay slip - ${getFullMonthYearFromDate(month)}`} backIcon="/main/paystubs" />
      )}

      <div className="employee-payslip-details-container">
        <div className="employee-paystubs-page-container">
          {!platformHeader && (
            <div className="flex items-center space-x-1 pt-05">
              <Box className="cursor-pointer" component="img" src={BackButtonIcon} onClick={() => navigate(-1)} />
              <div className="employee-paystubs-dA1-Menu">Pay Slip - {getFullMonthYearFromDate(month)}</div>
            </div>
          )}
          <EmployeeSlipsHeader
            open={open}
            setOpen={setOpen}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            filters={filters}
            setPayrollId={setPayrollId}
            openMonth={openMonth}
            setMonthOpen={setMonthOpen}
          />
          <br />

          {children}
        </div>
      </div>
    </div>
  );
}

export default PayslipPageLayout;
